export default "__VITE_ASSET__DxUjh9ns__"